module.exports = __webpack_public_path__ + "img/warehouse.a054861.webp";